function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function buildCardMarkup(item) {
  const title = escapeHtml(item.title || '')
  const link = escapeHtml(item.link || '')
  const date = escapeHtml(item.date || '')
  const excerpt = escapeHtml(item.excerpt || '')
  const image = escapeHtml(item.image || '')

  const imageHtml = image
    ? `<img src="${image}" alt="${title}" class="parallax" data-speed="-0.1" data-speed-mobile="0">`
    : ''

  return `
    <article class="card-post">
      <div class="line w-full xg:w-[60%] clipline" data-start="top 80%"></div>
      <div class="col-1-13 xg:col-1-3">
        <div class="date text-mini">${date}</div>
      </div>
      <div class="col-1-13 xg:col-3-9 relative z-10">
        <div class="info">
          <a href="${link}">
            <h3>${title}</h3>
            <p>${excerpt}</p>
          </a>
          <div class="hidden xg:block">
            <a href="${link}" class="btn-cta"><span>Leer más</span></a>
          </div>
        </div>
      </div>
      <div class="col-1-13 xg:col-9-13 relative z-0">
        <a href="${link}">
          <figure>
            ${imageHtml}
            <div class="xg:absolute xg:inset-0 xg:bg-gradient-to-r from-white/50 to-transparent z-10 trans"></div>
          </figure>
        </a>
        <div class="xg:hidden mt-4">
          <a href="${link}" class="btn-cta"><span>Leer más</span></a>
        </div>
      </div>
    </article>
  `
}

function initCategoryPaginationSystem() {
  const list = document.querySelector('.category-list')
  const paginationNav = document.getElementById('category-pagination')

  if (!list || !paginationNav) {
    return
  }

  const endpoint = list.dataset.endpoint || ''
  const category = list.dataset.category || ''
  const categoryId = list.dataset.categoryId || ''
  const excludeId = list.dataset.exclude || ''

  if (!endpoint || (!category && !categoryId)) {
    return
  }

  const state = list.__categoryPaginationState || {
    page: parseInt(list.dataset.currentPage || '1', 10) || 1,
    perPage: parseInt(list.dataset.perPage || '5', 10) || 5,
    totalPages: parseInt(list.dataset.totalPages || '1', 10) || 1,
    totalItems: parseInt(list.dataset.totalItems || '0', 10) || 0,
    isLoading: false,
    requestToken: 0
  }

  list.__categoryPaginationState = state

  const updateUrl = (page) => {
    const url = new URL(window.location)
    // Always include page parameter to ensure transitions.js excludes it
    url.searchParams.set('page', String(page))
    history.pushState({ categoryPage: page }, '', url)
  }

  const scrollToPosts = () => {
    const lenis = window.lenisInstance
    if (lenis) {
      lenis.scrollTo('#category-posts', { duration: 1.2 })
    } else {
      const el = document.getElementById('category-posts')
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const updateCounters = () => {
    const currentPageEl = document.getElementById('category-current-page-num')
    const totalPagesEl = document.getElementById('category-total-pages-num')
    const totalCounterEl = document.getElementById('category-total-counter')

    if (currentPageEl) currentPageEl.textContent = String(state.page)
    if (totalPagesEl) totalPagesEl.textContent = String(state.totalPages)

    // Update total posts count if we have the data from API
    if (totalCounterEl && state.totalItems > 0) {
      totalCounterEl.textContent = `${state.totalItems} posts en total`
    }
  }

  const renderPosts = (items) => {
    list.innerHTML = items.map((item) => buildCardMarkup(item)).join('')

    if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
      requestAnimationFrame(() => window.ScrollTrigger.refresh())
    }
  }

  let prevArrowHtml = null
  let nextArrowHtml = null

  const renderPagination = () => {
    if (state.totalPages <= 1) {
      paginationNav.style.display = 'none'
      return
    }

    if (!prevArrowHtml) {
      prevArrowHtml = paginationNav.querySelector('.pagination-prev')?.innerHTML || '&laquo;'
    }
    if (!nextArrowHtml) {
      nextArrowHtml = paginationNav.querySelector('.pagination-next')?.innerHTML || '&raquo;'
    }

    paginationNav.style.display = ''

    const current = state.page
    const total = state.totalPages
    const maxVisible = 5

    let startPage = Math.max(1, current - Math.floor(maxVisible / 2))
    let endPage = startPage + maxVisible - 1
    if (endPage > total) {
      endPage = total
      startPage = Math.max(1, endPage - maxVisible + 1)
    }

    let html = ''

    const prevDisabled = current <= 1
    html += `<button type="button" class="pagination-prev p-1 xg:p-2 ${prevDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-70'}" ${prevDisabled ? 'disabled' : ''} data-page="${current - 1}">`
    html += prevArrowHtml
    html += '</button>'

    if (startPage > 1) {
      html += `<button type="button" class="pagination-num px-2 xg:px-3 py-1 opacity-60 hover:opacity-100" data-page="1">1</button>`
      if (startPage > 2) {
        html += `<span class="px-1 opacity-40">&hellip;</span>`
      }
    }

    for (let p = startPage; p <= endPage; p++) {
      const isActive = p === current
      html += `<button type="button" class="pagination-num px-2 xg:px-3 py-1 ${isActive ? 'text-red font-semibold' : 'opacity-60 hover:opacity-100'}" data-page="${p}">${p}</button>`
    }

    if (endPage < total) {
      if (endPage < total - 1) {
        html += `<span class="px-1 opacity-40">&hellip;</span>`
      }
      html += `<button type="button" class="pagination-num px-2 xg:px-3 py-1 opacity-60 hover:opacity-100" data-page="${total}">${total}</button>`
    }

    const nextDisabled = current >= total
    html += `<button type="button" class="pagination-next p-1 xg:p-2 ${nextDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-70'}" ${nextDisabled ? 'disabled' : ''} data-page="${current + 1}">`
    html += nextArrowHtml
    html += '</button>'

    paginationNav.innerHTML = html
  }

  const setLoading = (value) => {
    state.isLoading = value
    list.dataset.loading = value ? '1' : '0'
  }

  const fetchPosts = async ({ scrollUp = false, updateHistory = true } = {}) => {
    if (state.isLoading) return

    const params = new URLSearchParams({
      page: String(state.page),
      per_page: String(state.perPage),
      exclude: excludeId
    })

    if (categoryId) {
      params.set('category_id', categoryId)
    } else if (category) {
      params.set('category', category)
    }

    state.requestToken += 1
    const currentToken = state.requestToken
    setLoading(true)

    try {
      const response = await fetch(`${endpoint}?${params.toString()}`, {
        method: 'GET',
        headers: { Accept: 'application/json' }
      })

      if (!response.ok) {
        throw new Error('No se pudieron cargar las publicaciones')
      }

      const data = await response.json()

      if (currentToken !== state.requestToken) return

      const items = Array.isArray(data.items) ? data.items : []
      renderPosts(items)

      state.page = data?.pagination?.page || state.page
      state.totalPages = data?.pagination?.total_pages || 1
      state.totalItems = data?.pagination?.total_items || state.totalItems
      list.dataset.currentPage = String(state.page)
      list.dataset.totalPages = String(state.totalPages)
      list.dataset.totalItems = String(state.totalItems)

      renderPagination()
      updateCounters()

      if (updateHistory) {
        updateUrl(state.page)
      }

      if (scrollUp) {
        scrollToPosts()
      }
    } catch (error) {
      console.error('[Categories] fetchPosts error:', error)
    } finally {
      setLoading(false)
    }
  }

  if (list.dataset.initialized !== 'true') {
    paginationNav.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-page]')
      if (!btn || btn.disabled) return

      const targetPage = parseInt(btn.dataset.page, 10)
      if (isNaN(targetPage) || targetPage < 1 || targetPage > state.totalPages) return
      if (targetPage === state.page) return

      state.page = targetPage
      fetchPosts({ scrollUp: true, updateHistory: true })
    })

    if (!window.__categoryPaginationPopstateBound) {
      window.addEventListener('popstate', () => {
        const pageFromUrl = parseInt(new URL(window.location).searchParams.get('page') || '1', 10) || 1
        if (pageFromUrl === state.page) return
        state.page = pageFromUrl
        fetchPosts({ scrollUp: false, updateHistory: false })
      })
      window.__categoryPaginationPopstateBound = true
    }

    list.dataset.initialized = 'true'
  }

  renderPagination()
  updateCounters()
}

function scheduleInitCategoryPaginationSystem() {
  initCategoryPaginationSystem()

  setTimeout(() => {
    initCategoryPaginationSystem()
  }, 120)

  setTimeout(() => {
    initCategoryPaginationSystem()
  }, 350)
}

function searchPaginationCategory() {
  window.__categoryPaginationHandledByModule = true
  scheduleInitCategoryPaginationSystem()

  if (!window.__categoryPaginationBarbaHookAdded && typeof barba !== 'undefined') {
    barba.hooks.after(() => {
      scheduleInitCategoryPaginationSystem()
    })
    window.__categoryPaginationBarbaHookAdded = true
  }

  if (!window.__categoryPaginationTransitionListenerAdded) {
    window.addEventListener('page-transition-complete', () => {
      scheduleInitCategoryPaginationSystem()
    })
    window.__categoryPaginationTransitionListenerAdded = true
  }
}

export default searchPaginationCategory
